import styled, { css } from 'styled-components';

export const Root = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
    min-width: 0;
    min-height: 0;
    width: ${theme.sz.s74};
    max-width: 100%;
    height: 100%;

    @media (max-width: ${theme.sz.lg}) {
      width: min(100%, ${theme.sz.s48});
      margin-inline: auto;
      height: auto;
    }
  `,
);

export const Stage = styled.div(
  ({ theme }) => css`
    position: relative;
    flex: 1;
    min-height: 0;
    width: 100%;
    border-radius: ${theme.bo.medium};
    overflow: hidden;
    background-color: ${theme.co.secondary20};

    @media (max-width: ${theme.sz.lg}) {
      flex: none;
      max-height: ${theme.sz.s64};
      aspect-ratio: 3 / 4;
    }
  `,
);

export const Video = styled.video(
  () => css`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    cursor: pointer;
  `,
);

export const AudioOnlyStage = styled.div<{ $isInteractive: boolean }>(
  ({ $isInteractive }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${$isInteractive ? 'pointer' : 'default'};
  `,
);

export const Scrim = styled.div(
  () => css`
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(41, 55, 73, 0.45) 0%,
      rgba(41, 55, 73, 0) 40%,
      rgba(41, 55, 73, 0) 100%
    );
  `,
);

export const Tag = styled.span(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.sz.s2};
    left: ${theme.sz.s2};
    z-index: 1;
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
    height: ${theme.sz.s6};
    padding: 0 ${theme.sz.s2};
    border-radius: ${theme.bo.round};
    background: rgba(0, 17, 34, 0.6);
    color: ${theme.co.neutral99};
    ${theme.typography.paragraph.s};
    font-weight: ${theme.DEPRECATED_ty.bold};
    letter-spacing: 0.04em;
    pointer-events: none;

    svg {
      width: ${theme.sz.s3};
      height: ${theme.sz.s3};
      color: ${theme.co.primary20};
    }
  `,
);

export const PlayButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s16};
    height: ${theme.sz.s16};
    padding: 0;
    border: none;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary20};
    color: ${theme.co.secondary0};
    cursor: pointer;
    transition: transform 150ms ease;

    &:hover {
      transform: translate(-50%, -50%) scale(1.06);
    }

    svg {
      width: ${theme.sz.s6};
      height: ${theme.sz.s6};
      margin-left: 2px;
    }

    @media (max-width: ${theme.sz.lg}) {
      width: ${theme.sz.s12};
      height: ${theme.sz.s12};

      svg {
        width: ${theme.sz.s5};
        height: ${theme.sz.s5};
      }
    }
  `,
);
